'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.siteHeader =
  twentyninetimes.siteHeader ||
  (function () {
    var site_body = document.body
    var doc = document.documentElement
    var w = window

    var prevScroll = w.scrollY || doc.scrollTop
    var curScroll
    var direction = 0
    var prevDirection = 0

    var header = document.getElementById('js-site-header'),
      header_height = header?.clientHeight
    const toggleButtons = document.querySelectorAll('.action-toggle')
    const overlay = document?.querySelector('.overlay')
    const closeButton = overlay?.querySelector('.close-button > div')

    function init() {
      if (header && toggleButtons) {
        // toggleHeader(header);
        overlayToggle(toggleButtons)
      }
    }

    function overlayToggle(toggleButtons) {
      function keyPress(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          closeOverlay()
        }
      }

      function closeOverlay() {
        const items = document.querySelectorAll('.item-open')

        items?.forEach((item, i) => {
          setTimeout(() => {
            item.classList.remove('item-open')
          }, i * 100)
        })

        overlay.classList = 'overlay'
        site_body.classList.remove('no-scroll')

        // clean up
        document.removeEventListener('keydown', keyPress)
      }

      if (closeButton) {
        closeButton.onclick = () => {
          closeOverlay()
        }
      }

      // actions loades to gange, så nødvendigt at loope over
      if (toggleButtons) {
        toggleButtons.forEach((button) => {
          button.onclick = () => {
            document.addEventListener('keydown', keyPress)

            site_body.classList.add('no-scroll')

            overlay.classList = 'overlay open'
            let items
            let focusField

            if (button.title == 'search') {
              overlay.classList.add('overlay__search')
              items = document.querySelectorAll('.search-form *')
              focusField = overlay.querySelector(
                ".search-form input[type='search']"
              )
              window.setTimeout(() => focusField.focus(), 300)
            }

            if (button.title == 'language') {
              // overlay.classList.add("overlay__language");
              items = document.querySelectorAll('.language-selector *')
            }

            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add('item-open')
              }, i * 200)
            })

            if (site_body.classList.contains('nav-active')) {
              site_body.classList.remove('nav-active')
            }
          }
        })
      }
    }

    function checkScroll() {
      /*
       ** Find the direction of scroll
       ** 0 - initial, 1 - up, 2 - down
       */

      curScroll = w.scrollY || doc.scrollTop

      curScroll > header_height
        ? header.classList.add('scrolled')
        : header.classList.remove('scrolled')

      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2
      } else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll)
      }

      prevScroll = curScroll
    }

    function toggleHeader(direction, curScroll) {
      if (direction === 2 && curScroll > header_height) {
        // site_body.classList.add('hide');
        header.classList.add('hide')
        prevDirection = direction
      } else if (direction === 1) {
        // site_body.classList.remove('hide');
        header.classList.remove('hide')
        prevDirection = direction
      }
    }

    return {
      init: init,
      checkScroll: checkScroll,
    }
  })()
